import _ from 'lodash';

import domains from '../containers/Domains';

const endpoint = domains.fbEndpoint;

const getLead = async (id, token) => {
  const parameters = {
    access_token: token,
    id,
    fields: 'id,leadgen_export_csv_url,locale,name,status'
  };

  const query = _.template(`${endpoint}<%= id%>?&fields=<%= fields%>&access_token=<%= access_token%>`);
  const result = await fetch(query(parameters));
  return result.json();
};

export { getLead as default };



// WEBPACK FOOTER //
// ./src/fbApi/Lead.js